/****
 *
 * 处理一些全局的跳转
 * ****/
import Vue from 'vue'
import router from '../../../router/index'
import api from '../api'
/***
 * 跳转印章管理
 * ***/

const JumpSeal = {
    msgObject:null,
    msgFn:function (data) {
        let _data = data.data.data;
        console.log(_data,"是否设置法人章");
        if(JumpSeal.msgObject){
            JumpSeal.msgObject.close();
        }
        let _this = new Vue();
        let h = _this.$createElement;
        let realName = '';
        if(_data.isAdmin === '1'){
            // 机构管理员
            // realName = h('div', {style:'width:auto;margin-right: 20px;'}, [
            //     h('span', {style: 'color: #e6a23c;font-size: 14px;'},
            //         `未设置法人章，请您先在【印章管理-印章授权】菜单中设置法人章，`),
            //     h('span', {
            //         style: 'color: #33A6FF;cursor: pointer;font-size: 14px;',
            //         on: {click: JumpSeal.to.bind(_this)}
            //     }, "点击设置")]);
                 realName = h('div', {style:'width:auto;margin-right: 20px;'}, [
                h('span', {style: 'color: #e6a23c;font-size: 14px;'},
                    `${data.data.message}`)
              ]);
        }else{
            //员工
            realName = h('div', {style:'width:auto;margin-right: 20px;'}, [
                h('span', {style: 'color: #e6a23c;font-size: 14px;'},
                    `${_data.message}`),]);
        }

        JumpSeal.msgObject = _this.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: realName,
            duration:5000,
            center:false,
            type: 'warning'
        });
        _this.$xLoading.close();
    },
    to:function (e) {
        JumpSeal.msgObject.close()
        router.push('/user/sealmanage');
        JumpSeal.msgObject = null;
    }
}

/***
 * 处理没有办理法人章的提示（code 777）
 * userType 2: 内部用户, 3/4: 外部用户
 * 外部用户：提供"立即办理印章"链接
 * 内部用户：仅提示信息
 ***/
const HandleNoLegalSeal = {
    msgObject: null,
    /**
     * 显示提示消息
     * @param {Object} data - 接口返回的数据
     * @param {string|number} data.code - 状态码（777）
     * @param {Object} data.data - 返回数据
     * @param {string} data.data.userType - 用户类型（2内部，3/4外部）
     */
    showMsg: function (data) {
        const _data = data.data || data;
        
        // 关闭之前的消息
        if (HandleNoLegalSeal.msgObject) {
            HandleNoLegalSeal.msgObject.close();
        }
        
        const _this = new Vue();
        const h = _this.$createElement;
        const userType = _data.userType;
        // userType 2: 内部用户, 3/4: 外部用户
        const isExternal = userType == '3' || userType == '4';
        
        let messageContent = '';
        
        if (isExternal) {
            // 外部用户：显示提示，提供办理印章链接
            messageContent = h('div', { style: 'display: flex; align-items: center; min-width: 600px;' }, [
                h('span', { style: 'color: #f56c6c;font-size: 14px;' },
                    '出错了！失败原因：没有办理法人章，不能签署，请点击'),
                h('span', {
                    style: 'color: #409EFF;cursor: pointer;font-size: 14px;margin: 0 4px;',
                    on: { click: HandleNoLegalSeal.handleOnlineSeal.bind(_this) }
                }, '立即办理印章'),
                h('span', { style: 'color: #f56c6c;font-size: 14px;' },
                    '办理印章。')
            ]);
        } else {
            // 内部用户：仅提示信息
            messageContent = h('div', { style: 'display: flex; align-items: center; min-width: 320px;' }, [
                h('span', { style: 'color: #f56c6c;font-size: 14px;' },
                    '出错了！失败原因：没有办理法人章不能签署。')
            ]);
        }
        
        HandleNoLegalSeal.msgObject = _this.$message({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: messageContent,
            duration: 5000, // 不自动关闭
            center: false,
            type: 'error'
        });
        
        // 关闭加载动画
        if (_this.$xLoading) {
            _this.$xLoading.close();
        }
    },
    /**
     * 在线办理印章
     */
    handleOnlineSeal: function () {
        api.menu.ssoUmsp().then(res => {
            if (res.data.code == 0 || res.data.code == '0') {
                window.open(res.data.message, '_blank');
            } else {
                const _this = new Vue();
                _this.$message({
                    message: res.data.message,
                    type: 'error',
                    center: true
                });
            }
        }).catch(err => {
            const _this = new Vue();
            _this.$message.error('跳转办理印章失败');
        });
    },
    /**
     * 关闭消息
     */
    close: function () {
        if (HandleNoLegalSeal.msgObject) {
            HandleNoLegalSeal.msgObject.close();
            HandleNoLegalSeal.msgObject = null;
        }
    }
}


export {
    JumpSeal,
    HandleNoLegalSeal
};



// WEBPACK FOOTER //
// ./src/assets/js/tools/tools.js